import React from "react";
import { Navigate } from "react-router-dom";
import { getUser, setReturnURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

const UserPrivateRoute = ({ component: Component }) => {
  //   const userData = getUser(ROLE.USER)
  return (
    <>
      {(function () {
        // if (Object.keys(userData).length && userData.token) {
        if (true) {
          return <Component />;
        } else {
          setReturnURL(ROLE.USER);
          return <Navigate to="/user/login" />;
        }
      })()}
    </>
  );
};

export default UserPrivateRoute;
